import { Factory } from './factory';
import { TextSelection } from '../text-selection';
import { TextBox } from '../text-box';

export class TextSelectionFactory implements Factory<TextSelection> {

    buildFromFactory(): TextSelection {
        return undefined;
    }

    buildFromObject(jsonObject: any): TextSelection {
        const textSelection = new TextSelection();
        textSelection.id = jsonObject.id;
        textSelection.pageId = jsonObject.pageId;
        textSelection.startBox = TextBox.createEmptyTextBox();
        textSelection.endBox = TextBox.createEmptyTextBox();
        textSelection.startBox.index = +jsonObject.startIndex;
        textSelection.endBox.index = +jsonObject.endIndex;
        textSelection.pageId = +jsonObject.pageId;
        textSelection.updatedAt = jsonObject.updatedAt;

        return textSelection;
    }

}
